// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/PalaceScriptMT.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/menu_background_rotated_min.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Palace Script MT';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-size: 120%;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  margin: 0;
}

#gallery h1 {
  color: #333; /* Warm brown color */
  font-family: Georgia, serif;
  font-size: 3rem;
  padding-bottom: 5%;
  animation: fadeIn 1s ease-in; /* Add fade-in animation */
}

.gallery-title-g {
  font-family: 'Palace Script MT', cursive;
  font-size: 8rem;
  color: #333;
  animation: fadeIn 1s ease-in; /* Add fade-in animation */
}

.carousel-container {
  width: 80%; /* Adjust width as needed */
  margin: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 1);
  animation: fadeIn 1s ease-in; /* Add fade-in animation */
}

.carousel-image {
  height: 600px; /* Adjust height as needed */
  object-fit: cover; /* Maintain aspect ratio */
  cursor: pointer;
  /* animation: fadeIn 1s ease-in; Add fade-in animation */
}

.carousel-caption {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 5px;
}

.modal-body {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh; /* Adjust height to fit screen */
  position: relative; /* To position navigation buttons */
}

.modal-dialog {
  max-width: 80%; /* Adjust the max width to your preference */
}

.modal-content {
  background-color: transparent;
  border: none;
}

.modal-img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ensure the image fits the modal without distortion */
}

.title-end {
  font-size: 3rem;
  color: #333;
}

.modal-nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #333; /* Background color */
  color: white; /* Arrow color */
  border: none;
  font-size: 2rem;
  cursor: pointer;
  z-index: 10;
  padding: 10px;
  opacity: 0.5;
}

.modal-nav-button:hover {
  background-color: #333; /* Darker on hover */
  opacity: 1;
}

.modal-nav-button:first-of-type {
  left: 0;
}

.modal-nav-button:last-of-type {
  right: 0;
}

/* New CSS for full-screen modal image */
.modal-90w {
  max-width: 90%;
}

.modal-body-custom {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-body-custom img {
  max-width: 100%;
  max-height: 100vh;
  object-fit: contain;
}

.modal-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  font-size: 2rem;
  padding: 0.5rem 1rem;
  z-index: 1051;
}

.modal-prev {
  left: 0;
}

.modal-next {
  right: 0;
}

/* Fade-in animation keyframes */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Media Queries for Mobile Devices */
@media (max-width: 768px) {
  #gallery h1 {
    padding-bottom: 3% !important;
    padding-top: 0% !important;
  }

  .gallery-title-g {
    font-size: 6rem !important; /* Adjust font size */
  }

  .carousel-container {
    width: 100%; /* Full width on mobile */
    margin: auto;
    box-shadow: none; /* Remove shadow on mobile */
  }

  .carousel-image {
    height: 300px; /* Adjust height for mobile */
  }

  .modal-body-custom img {
    max-width: 100%;
    max-height: 80vh; /* Adjust height for mobile */
    object-fit: contain;
  }

  .modal-nav {
    font-size: 1.5rem; /* Adjust font size */
    padding: 0.5rem; /* Adjust padding */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/gallery/Gallery.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,+DAAoE;AACtE;;AAEA;EACE,yDAAqE;EACrE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE,UAAU,EAAE,2BAA2B;EACvC,YAAY;EACZ,yCAAyC;EACzC,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE,aAAa,EAAE,4BAA4B;EAC3C,iBAAiB,EAAE,0BAA0B;EAC7C,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,gCAAgC;EAC9C,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA;EACE,cAAc,EAAE,4CAA4C;AAC9D;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,uDAAuD;AAC9E;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB,EAAE,qBAAqB;EAC7C,YAAY,EAAE,gBAAgB;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB,EAAE,oBAAoB;EAC5C,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,wCAAwC;AACxC;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B,EAAE,qBAAqB;EACnD;;EAEA;IACE,WAAW,EAAE,yBAAyB;IACtC,YAAY;IACZ,gBAAgB,EAAE,4BAA4B;EAChD;;EAEA;IACE,aAAa,EAAE,6BAA6B;EAC9C;;EAEA;IACE,eAAe;IACf,gBAAgB,EAAE,6BAA6B;IAC/C,mBAAmB;EACrB;;EAEA;IACE,iBAAiB,EAAE,qBAAqB;IACxC,eAAe,EAAE,mBAAmB;EACtC;AACF","sourcesContent":["@font-face {\n  font-family: 'Palace Script MT';\n  src: url('../../assets/fonts/PalaceScriptMT.ttf') format('truetype');\n}\n\nbody {\n  background-image: url('../../assets/menu_background_rotated_min.jpg');\n  background-size: cover;\n  background-size: 120%;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 100vh;\n  margin: 0;\n}\n\n#gallery h1 {\n  color: #333; /* Warm brown color */\n  font-family: Georgia, serif;\n  font-size: 3rem;\n  padding-bottom: 5%;\n  animation: fadeIn 1s ease-in; /* Add fade-in animation */\n}\n\n.gallery-title-g {\n  font-family: 'Palace Script MT', cursive;\n  font-size: 8rem;\n  color: #333;\n  animation: fadeIn 1s ease-in; /* Add fade-in animation */\n}\n\n.carousel-container {\n  width: 80%; /* Adjust width as needed */\n  margin: auto;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 1);\n  animation: fadeIn 1s ease-in; /* Add fade-in animation */\n}\n\n.carousel-image {\n  height: 600px; /* Adjust height as needed */\n  object-fit: cover; /* Maintain aspect ratio */\n  cursor: pointer;\n  /* animation: fadeIn 1s ease-in; Add fade-in animation */\n}\n\n.carousel-caption {\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.modal-body {\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh; /* Adjust height to fit screen */\n  position: relative; /* To position navigation buttons */\n}\n\n.modal-dialog {\n  max-width: 80%; /* Adjust the max width to your preference */\n}\n\n.modal-content {\n  background-color: transparent;\n  border: none;\n}\n\n.modal-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain; /* Ensure the image fits the modal without distortion */\n}\n\n.title-end {\n  font-size: 3rem;\n  color: #333;\n}\n\n.modal-nav-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #333; /* Background color */\n  color: white; /* Arrow color */\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  z-index: 10;\n  padding: 10px;\n  opacity: 0.5;\n}\n\n.modal-nav-button:hover {\n  background-color: #333; /* Darker on hover */\n  opacity: 1;\n}\n\n.modal-nav-button:first-of-type {\n  left: 0;\n}\n\n.modal-nav-button:last-of-type {\n  right: 0;\n}\n\n/* New CSS for full-screen modal image */\n.modal-90w {\n  max-width: 90%;\n}\n\n.modal-body-custom {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-body-custom img {\n  max-width: 100%;\n  max-height: 100vh;\n  object-fit: contain;\n}\n\n.modal-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.5);\n  border: none;\n  color: white;\n  font-size: 2rem;\n  padding: 0.5rem 1rem;\n  z-index: 1051;\n}\n\n.modal-prev {\n  left: 0;\n}\n\n.modal-next {\n  right: 0;\n}\n\n/* Fade-in animation keyframes */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Media Queries for Mobile Devices */\n@media (max-width: 768px) {\n  #gallery h1 {\n    padding-bottom: 3% !important;\n    padding-top: 0% !important;\n  }\n\n  .gallery-title-g {\n    font-size: 6rem !important; /* Adjust font size */\n  }\n\n  .carousel-container {\n    width: 100%; /* Full width on mobile */\n    margin: auto;\n    box-shadow: none; /* Remove shadow on mobile */\n  }\n\n  .carousel-image {\n    height: 300px; /* Adjust height for mobile */\n  }\n\n  .modal-body-custom img {\n    max-width: 100%;\n    max-height: 80vh; /* Adjust height for mobile */\n    object-fit: contain;\n  }\n\n  .modal-nav {\n    font-size: 1.5rem; /* Adjust font size */\n    padding: 0.5rem; /* Adjust padding */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
